import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const MissionStatsAction = createAsyncThunk(
    'mission-stats',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/mission-stats`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const MissionStatsSlice = createSlice({
    name: 'mission-stats',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(MissionStatsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(MissionStatsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(MissionStatsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const missionStatsReducer = MissionStatsSlice.reducer
